import { render, staticRenderFns } from "./RebootTab.vue?vue&type=template&id=530213e2"
import script from "./RebootTab.vue?vue&type=script&lang=js"
export * from "./RebootTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports